module.exports = "/_next/static/images/02eb21b023385a4c3ba6bea426ff44a5-savings-waitlist-promise-3b-lg-1x.jpg";